import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;

/**
 * PLACEHOLDER CONTENT.
 * The three cases rendered here come from i18n/escaCopy.ts and are illustrative
 * constructions, not real client stories. Replace them with verified cases
 * before the site goes live.
 */
export function CasesSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cases" className="bg-white py-20 lg:py-28" ref={ref} data-id="element-210" data-mp="140kz752edl19">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-211" data-mp="18w9qym86dxn0">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        ease: EASE
      }} className="max-w-[44rem]" data-id="element-212" data-mp="1dwxs40q4buuy">
          <h2 className="esca-h2 text-ink text-balance" data-id="element-213" data-mp="3rhq5vjb62m5a">{c.cases.title}</h2>
          <p className="esca-lead mt-6 text-muted max-w-[52ch]" data-id="element-214" data-mp="3min0fxr9ydws">
            {c.cases.lead}
          </p>
        </motion.div>

        <div className="mt-12 lg:mt-16 grid lg:grid-cols-3 gap-6" data-id="element-215" data-mp="3hiilwd9xft97">
          {c.cases.items.map((item, i) => {
          return <motion.article key={item.role + item.industry} initial={{
            opacity: 0,
            y: 16
          }} animate={inView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.1 + i * 0.08,
            ease: EASE
          }} className="flex flex-col border border-line bg-white" data-id="element-216" data-mp="3dji1wrfpqkkm" data-mpi={i}>
                <div className="p-7 lg:p-8 flex-1 flex flex-col" data-id="element-217" data-mp="wt1jjr1fpar6">
                  <h3 className="font-display text-[2rem] lg:text-[2.5rem] font-bold text-ink tracking-[-0.04em] leading-none" data-id="element-218" data-mp="wucldlbbk8fn">
                    {item.role}
                  </h3>

                  <dl className="mt-6 space-y-2.5 pb-6 border-b border-line" data-id="element-219" data-mp="2mbi07gfvrhiv">
                    <div className="flex gap-3 text-[0.8125rem]" data-id="element-220" data-mp="2r9jihz5hfcta">
                      <dt className="w-24 flex-shrink-0 text-muted" data-id="element-221" data-mp="2ckdhq6qzxeja">
                        {c.cases.industryLabel}
                      </dt>
                      <dd className="text-ink" data-id="element-222" data-mp="2hi5m408tut4d">{item.industry}</dd>
                    </div>
                    <div className="flex gap-3 text-[0.8125rem]" data-id="element-223" data-mp="23inqb0x46fli">
                      <dt className="w-24 flex-shrink-0 text-muted" data-id="element-224" data-mp="28iijjb4d3h9q">
                        {c.cases.geoLabel}
                      </dt>
                      <dd className="text-ink" data-id="element-225" data-mp="1tmt45vtom2dz">{item.geo}</dd>
                    </div>
                  </dl>

                  <div className="mt-6" data-id="element-226" data-mp="1yl4dm5g2eavo">
                    <p className="esca-eyebrow text-muted" data-id="element-227" data-mp="3nziwwa8bd5js">
                      {c.cases.challengeLabel}
                    </p>
                    <p className="mt-2.5 text-[0.9375rem] text-ink leading-relaxed" data-id="element-228" data-mp="3syvhspfmk2jq">
                      {item.challenge}
                    </p>
                  </div>

                  <div className="pt-6" data-id="element-229" data-mp="1ccgu31w5rqq6">
                    <p className="esca-eyebrow text-muted" data-id="element-230" data-mp="1cdi4r599ib7d">
                      {c.cases.approachLabel}
                    </p>
                    <p className="mt-2.5 text-[0.9375rem] text-ink leading-relaxed" data-id="element-231" data-mp="1r369kggnjrzu">
                      {item.approach}
                    </p>
                  </div>

                  <div className="mt-auto pt-7" data-id="element-232" data-mp="200ghpsy6b10j">
                    <p className="esca-eyebrow text-accent" data-id="element-233" data-mp="1w06bqgadsalo">
                      {c.cases.resultLabel}
                    </p>
                    <p className="mt-2.5 font-display text-lg font-semibold text-ink tracking-[-0.02em] leading-snug" data-id="element-234" data-mp="2a07c7umqhg0m">
                      {item.result}
                    </p>
                  </div>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}